import { useContext } from 'react'
import { SiteSettingsContext } from '../contexts/siteSettingsStore'

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext)
  if (!context) {
    throw new Error('useSiteSettings doit être utilisé dans SiteSettingsProvider')
  }
  return context
}
